// Build all payment fields from the same basket, independent of URL parameters.
export const buildRewardSelection = (items = []) => {
  const selected = Array.isArray(items)
    ? items.filter((item) => item?.id != null)
    : [];
  const rewardIds = selected.map((item) => item.id);
  const rewardQuantities = {};
  const answers = selected.flatMap((item) => {
    const rewardId = item.id.toString();
    const quantity = Math.max(1, Number(item.quantity) || 1);
    rewardQuantities[item.id] = quantity;

    const rawAnswers = Array.isArray(item.answers) ? item.answers : [];
    const values =
      rawAnswers[0]?.toString() === rewardId
        ? rawAnswers.slice(1)
        : rawAnswers;
    const fieldCount =
      (item?.variants?.length || 0) +
      (item?.questions?.length || 0) +
      (item?.extra_details ? 1 : 0);

    if (fieldCount > 0 && values.length >= fieldCount * quantity) {
      return Array.from({ length: quantity }, (_, ticketIndex) => [
        rewardId,
        ...values.slice(ticketIndex * fieldCount, (ticketIndex + 1) * fieldCount),
      ]);
    }

    // Older baskets contain one answer set; repeat it for each ticket.
    return Array.from({ length: quantity }, () => [
      rewardId,
      ...values.slice(0, fieldCount || values.length),
    ]);
  });

  return { rewardIds, rewardQuantities, answers };
};
